module.exports = __webpack_public_path__ + "img/logo.49c1f156.png";